<template>
  <div class="min-h-screen flex flex-col relative overflow-hidden bg-gradient-to-b from-indigo-50 via-white to-white">
    <!-- Ambient glows -->
    <div class="absolute top-0 -left-32 w-[500px] h-[500px] bg-indigo-200/40 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute top-0 right-0 w-[400px] h-[400px] bg-purple-200/25 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-indigo-100/30 rounded-full blur-3xl pointer-events-none"></div>

    <!-- Header -->
    <header class="pt-8 pb-4 text-center relative z-10">
      <a :href="marketingUrl" class="inline-flex items-center gap-3 group">
        <img
          :src="logoUrl"
          alt="Smart Teacher"
          class="w-10 h-10 drop-shadow-lg group-hover:scale-105 transition-transform"
        />
        <span class="text-xl font-bold text-gray-900">Smart Teacher</span>
      </a>
    </header>

    <!-- Content -->
    <main class="flex-1 flex items-center justify-center px-4 sm:px-6 py-4 relative z-10">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="py-3 text-center text-gray-400 text-sm relative z-10">
      <p>&copy; {{ new Date().getFullYear() }} Smart Teacher. All rights reserved.</p>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import logoUrl from '@/assets/logo.svg'

const marketingUrl = import.meta.env.VITE_MARKETING_URL || 'https://smart-teacher.net'

// Set html/body background to match the gradient edge color
const AUTH_BG = '#eef2ff' // indigo-50 — matches the gradient top
let originalBg = ''

onMounted(() => {
  originalBg = document.body.style.backgroundColor
  document.documentElement.style.backgroundColor = AUTH_BG
  document.body.style.backgroundColor = AUTH_BG
})

onUnmounted(() => {
  document.documentElement.style.backgroundColor = ''
  document.body.style.backgroundColor = originalBg
})
</script>
